<template>
  <mc-exercise-frame>
    <div class="mc-layout-plotter-container">
      <!-- LEFT -->
      <div class="mc-plotter-left-side" ref="plottersLeftSide">
        <div class="container">
          <output-frames :output-frames="outputFramesLeft"></output-frames>
        </div>
      </div>
      <!-- RIGHT -->
      <div class="mc-plotter-right-side" ref="plottersRightSide">
        <div class="container">
          <image-box :images="images" />
        </div>
      </div>
    </div>
  </mc-exercise-frame>
</template>

<script>
import ImageBox from "./image-box.vue";
import McExerciseFrame from "../base/mc-exercise-frame.vue";
import OutputFrames from "../base/output/output-frames.vue";

import { resolveUrl } from "../base/layout-bom";

function isImageFragment(fragment) {
  let isImage = fragment.uiType === "mc/media/image";
  let isPlotterImage = fragment.plotterImage === true;
  return isImage && isPlotterImage;
}

export default {
  components: {
    ImageBox,
    McExerciseFrame,
    OutputFrames
  },
  computed: {
    /**
     * Alle Ausgaben - außer Bilder - auf die linke
     * Seite. Gibt OutputFrames zurück.
     */
    outputFramesLeft() {
      let outputFrames = this.$store.state.outputFrames || [];
      return outputFrames.map(frame => ({
        ...frame,
        fragments: frame.fragments.filter(f => !isImageFragment(f))
      }));
    },
    /**
     * Bilder auf die rechte Seite. Gibt nur die
     * Bild-Fragmente zurück!
     */
    imageFragments() {
      let outputFrames = this.$store.state.outputFrames || [];
      return outputFrames
        .reduce((a, frame) => [...a, ...frame.fragments], [])
        .filter(fragment => isImageFragment(fragment));
    },
    images() {
      const layout = this.$store.state.layout;
      const firstTop =  layout && layout.config && layout.config['direction'] === "first-top" ? true : false;
      const count = this.imageFragments.length;
      let images = this.imageFragments.map((f,i) => ({
        url: resolveUrl(f.url),
        title: f.title || "",
        width: f.width,
        height: f.height,
        caption : `Grafik ${i+1} von ${count}`,
        scrollTo : (i === (count-1))
      }));
      if(firstTop){
        return images.reverse();
      }
      return images;
    }, 
  }
};
</script>
 

<style scoped>
.mc-layout-plotter-container {
  position: absolute;
  overflow-y: hidden;
  overflow-x: hidden;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
}

/* ======================================== */
/* == full size, output left, plotter right */
/* ======================================== */
@media (min-width: 800px) {
  .mc-plotter-left-side {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: 50%;
    overflow: auto;
    border-right: solid 2px lightgray;
  }
  .mc-plotter-right-side {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    width: 50%;
    overflow: auto;
    padding-top: 10px;
  }
}

/* ========================================== */
/* == small size, plotter top, outputs bottom */
/* ========================================== */
@media (max-width: 800px) {
  .mc-plotter-left-side {
    position: absolute;
    height: 50%;
    bottom: 0;
    left: 0;
    right: 0;
    overflow: auto;
    border-top: solid 2px lightgray;
  }
  .mc-plotter-right-side {
    position: absolute;
    height: 50%;
    top: 0;
    right: 0;
    left: 0;
    overflow: auto;
    padding-top: 10px;
  }
}
</style>